import SpotifyWebAPILib from 'spotify-web-api-js';
import { getValidTokenAsync } from './spotifyLamdaRoutes';

// TODO: Figure out how to set the access token for the wrapper in the constructor
class SpotifyWebApi {
  // JUST like spotify web api _getSpotifyClientAsync
  async _getSpotifyClientAsync() {
    const token = await getValidTokenAsync();
    const client = new SpotifyWebAPILib();
    client.setAccessToken(token);
    return client;
  }

  async getMultipleArtists(artistIds: string[]) {
    try {
      const client = await this._getSpotifyClientAsync();
      const artists = client.getArtists(artistIds);
      return artists;
    } catch (error) {
      const errorMessage = error.responseText || error;
      console.error(
        'There was an issue fetching spotify artist data: ',
        errorMessage,
      );
      return error;
    }
  }
  async getMultipleTracks(trackIds: string[]) {
    try {
      const client = await this._getSpotifyClientAsync();
      const artists = client.getTracks(trackIds);
      return artists;
    } catch (error) {
      const errorMessage = error.responseText || error;
      console.error(
        'There was an issue fetching spotify track data: ',
        errorMessage,
      );
      throw error;
    }
  }
  async getUserProfile() {
    try {
      const client = await this._getSpotifyClientAsync();
      const user = await client.getMe();
      return user;
    } catch (error) {
      const errorMessage = error.responseText || error;
      console.error(
        'There was an issue retrieving user profile: ',
        errorMessage,
      );
      return error;
    }
  }
  async saveTracks(trackIds: string[]) {
    try {
      const client = await this._getSpotifyClientAsync();
      client.addToMySavedTracks(trackIds);
    } catch (error) {
      const errorMessage = error.responseText || error;
      console.error('There was an issue saving tracks: ', errorMessage);
      return error;
    }
  }

  async removeSavedTracks(trackIds: string[]) {
    try {
      const client = await this._getSpotifyClientAsync();
      client.removeFromMySavedTracks(trackIds);
    } catch (error) {
      const errorMessage = error.responseText || error;
      console.error('There was an issue removing saved tracks: ', errorMessage);
      return error;
    }
  }
  async artistsToFollow(artistIds: string[]) {
    try {
      const client = await this._getSpotifyClientAsync();
      client.followArtists(artistIds);
    } catch (error) {
      const errorMessage = error.responseText || error;
      console.error('There was an issue following artist: ', errorMessage);
      return error;
    }
  }

  async unfollowArtists(artistIds: string[]) {
    try {
      const client = await this._getSpotifyClientAsync();
      client.unfollowArtists(artistIds);
    } catch (error) {
      const errorMessage = error.responseText || error;
      console.error('There was an issue UNfollowing artist: ', errorMessage);
      return error;
    }
  }
  async checkIfUserTracksSaved(trackIds: string[]) {
    try {
      const client = await this._getSpotifyClientAsync();
      const savedTracks = client.containsMySavedTracks(trackIds);
      return savedTracks;
    } catch (error) {
      const errorMessage = error.responseText || error;
      console.error(
        "There was an issue retrieving user's saved tracks: ",
        errorMessage,
      );
      return error;
    }
  }
  async checkIfUserArtistsSaved(artistIds: string[]) {
    try {
      const client = await this._getSpotifyClientAsync();
      const isfollowingArtists = client.isFollowingArtists(artistIds);
      return isfollowingArtists;
    } catch (error) {
      const errorMessage = error.responseText || error;
      console.error(
        "There was an issue retrieving user's followed artists: ",
        errorMessage,
      );
      return error;
    }
  }
  /* 
  TODO: Add following endpoints:  
  1. Get users saved tracks to determine if they like a song already
  2. Get users saved artists to determine if they like an artist already
  **/
}

const SpotifyWebApiSingleton = new SpotifyWebApi();
export default SpotifyWebApiSingleton;

// export type Track = {
//   id: string;
//   name: string;
//   uri: string;
//   images: string[];
//   artists: string[];
//   isPlayable: boolean;
//   durationMs: number;
// };

// export async function playTrackAsync({
//   uri,
//   deviceId,
//   time,
// }: {
//   uri: string;
//   deviceId: string;
//   time?: number;
// }) {
//   const client = await _getSpotifyClientAsync();
//   return await client.play({
//     uris: [uri],
//     device_id: deviceId,
//     position_ms: time ?? 0,
//   });
// }

// export async function pauseAsync(): Promise<void> {
//   const client = await _getSpotifyClientAsync();
//   return await client.pause();
// }
